export { type TabProps, Tabs, type TabsProps } from "./Tabs.component";
